import React from 'react';
import { connect } from 'react-redux'
import DistribucionLimites from './DistribucionLimites.jsx';

//Importación de actions.
import {
    getScreenData,
    changeLimite,
    selectAdministradora,
    guardar,
    cancelar,
    cambiarEstadoEdicionEmpresa,
    cambiarEstadoEdicionCuenta,
    cambiarEstadoEdicionTarjeta,
    closeModalEstaEditando,
    obtenerLimiteCuentaPorProducto
} from '../actions/DistribucionLimitesActions.js';


const mapStateToProps = (state) => {
    return {
        data: state.distribucionLimites,
        datosCliente: state.tarjetas.clienteResultadoBusqueda,
        tarjetas: state.tarjetas,
        sesion: state.sesion
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope, cliente, storeTarjetas, getDatosFromDB, sesion) => {
            dispatch(getScreenData(currentScope, cliente, storeTarjetas, getDatosFromDB, sesion));
        },
        changeLimite: (id) => {
            dispatch(changeLimite(id));
        },
        selectAdministradora: (id) => {
            dispatch(selectAdministradora(id));
        },
        guardar: (cerrarmodal, guardaBBDD)  => {
            dispatch(guardar(cerrarmodal, guardaBBDD)  );
        },
        cancelar: (cerrarModal) => {
            dispatch(cancelar(cerrarModal));
        },
        cambiarEstadoEdicionEmpresa: (estado) => {
            dispatch(cambiarEstadoEdicionEmpresa(estado));
        },
        cambiarEstadoEdicionCuenta: (estado) => {
            dispatch(cambiarEstadoEdicionCuenta(estado));
        },
        cambiarEstadoEdicionTarjeta: (estado) => {
            dispatch(cambiarEstadoEdicionTarjeta(estado));
        },
        closeModalEstaEditando: () => {
            dispatch(closeModalEstaEditando());
        },
        obtenerLimiteCuentaPorProducto: (cuentas, id) => {
            dispatch(obtenerLimiteCuentaPorProducto(cuentas, id));
        }
    }
}

//Connect entre el componente y las props y actions.
const DistribucionLimitesContainer = connect(mapStateToProps, mapDispatchToProps)(DistribucionLimites);

export default DistribucionLimitesContainer;